export default {
  title: "GCORPcx",
};
